export default {
  title: "GCORPcx",
};
